// 通用 CSV 导出（前端生成文件，UTF-8 BOM 兼容 Excel 中文）
// columns: [{ key, title }]   rows: 对象数组（键与 columns.key 对应）
// 用法：exportCsv('操作日志.csv', columns, rows)
export function exportCsv(filename, columns, rows) {
  const escape = (v) => {
    if (v === null || v === undefined) return ''
    let s = typeof v === 'object' ? JSON.stringify(v) : String(v)
    if (/[",\n\r]/.test(s)) {
      s = '"' + s.replace(/"/g, '""') + '"'
    }
    return s
  }

  const header = columns.map((c) => escape(c.title)).join(',')
  const body = (rows || [])
    .map((row) => columns.map((c) => escape(row[c.key])).join(','))
    .join('\r\n')
  const csv = '﻿' + header + '\r\n' + body

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}
